/* eslint-disable import/prefer-default-export */
import {
  BRAINTREE_COMMON_TYPES,
  STRIPE_COMMON_TYPES,
} from '../constants/paymentProcessors';

const isCommonType = (type) => STRIPE_COMMON_TYPES.includes(type) || BRAINTREE_COMMON_TYPES.includes(type);

export {
  isCommonType,
};
